export default __webpack_public_path__ + "static/media/cardimage6.44d4b8d8.png";